import React from 'react';
import resources from '../../resources';
import { Timeline } from 'antd';
import languages from '../../appdata/languages';
import StoreManager from '../../appdata';

class AboutContent extends React.Component {
  render() {
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const t = languages[lang].AboutContent;
    const {isMobile} = StoreManager.appState.thisApp.state
    return (
      <div>
        {/* OUR STORY + CHART */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, marginBottom: 40 }}>
          <div style={{ flex: 1, minWidth: 280, borderRadius: 16, padding: 0 }}>
            <h3 style={{ fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 600 }}>{t.ourStoryTitle}</h3>
            <p style={{ lineHeight: 1.6 }}>{t.ourStoryText}</p>
          </div>

          <div style={{ flex: 1, minWidth: 280, borderRadius: 16, padding: 0 }}>
            {/* <h4 style={{ fontWeight: 600, fontSize: 16, marginBottom: 16 }}>{t.revenueTitle}</h4> */}
            <img src={lang == 'vi'? resources.images.about_revenue_chart_vi: resources.images.about_revenue_chart} alt="Revenue Chart" style={{ width: '100%', borderRadius: 8 }} />
            {/* <div style={{ fontSize: 12, color: '#666', marginTop: 8 }}>
              <div><span style={{ color: '#4285F4' }}>■</span> {t.revenueLegend1}</div>
              <div><span style={{ color: '#F15A24' }}>■</span> {t.revenueLegend2}</div>
            </div> */}
          </div>
        </div>

        {/* BUSINESS PILLARS */}
        <div style={{ marginBottom: 32 }}>
          <h3 style={{ fontSize: 24, fontWeight: 600, marginBottom: 16 }}>{t.pillarTitle}</h3>
          <ul style={{ lineHeight: 1.8 }}>
            {t.pillarList.map((item, idx) => <li key={idx}>{item}</li>)}
          </ul>
        </div>

        {/* PILLAR IMAGE + TEXT BLOCK */}
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 40 }}>
          <div style={{ flex: '0 0 auto', marginRight: 24 }}>
            <img src={lang == 'vi' ? resources.images.AboutImage1_vi : resources.images.AboutImage1} alt="Three Pillars" style={{ maxWidth: 240 }} />
          </div>
          <div style={{ flex: 1, minWidth: 260 }}>
            <p style={{ fontSize: 16, lineHeight: 1.6 }}>{t.strategyText}</p>
          </div>
        </div>

        {/* TIMELINE IMAGE + TEXT BLOCK */}
        <div style={{ marginBottom: 0, marginTop: 80 }}>
          <img src={resources.images.AboutImage2} alt="Timeline" style={{ width: '100%', borderRadius: 16 }} />
          <Timeline style={{ marginTop: 40 }}>
            {t.timeline.map((item, idx) => (
              <Timeline.Item key={idx}>
                <div style={{ fontSize: 16, lineHeight: '24px', color: '#212121' }}>
                  <b>{item.year}</b>: {item.text}
                </div>
              </Timeline.Item>
            ))}
          </Timeline>
        </div>


        {/* FINAL SECTION - IMPACT + BACKGROUND */}
        <div style={{
          backgroundImage: `url(${resources.images.AboutBottomBacground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: 16,
          padding: '0px 20px 24px',
          color: 'white'
        }}>
          <div style={{ maxWidth: 760, margin: '0 auto', marginBottom: 200 }}>
            {t.finalBlocks.map((block, idx) => (
              <div key={idx} style={{
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: 16,
                color: '#1A1A1A',
                lineHeight: 1.7,
                marginBottom: 10,
                padding: '5px 20px 10px',
              }}>
                <p style={{ fontWeight: 600, fontFamily:'Inter28-SemiBold' }}>{block.title}</p>
                {block.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                {block.italic && <p style={{ fontStyle: 'italic', color: '#004A8F' }}>{block.italic}</p>}
              </div>
            ))}
          </div>
        </div>

      </div>
    );
  }
}

export default AboutContent;
